export default "__VITE_ASSET__Cb82OABP__"